<template>
  <div class="mt-5" v-async="loading">
    <div class="row mb-2">
      <form-row-header text="Upload de Arquivos" />
    </div>
    <input-upload-field
      :modelProp="model"
      ref="inputUploadField"
      :disabled="
        !this.$can('CENTRAL_CADASTROS_EDITAR') &&
        !this.$can('CENTRAL_CADASTROS_APROVAR') &&
        !this.$can('CENTRAL_CADASTROS_PARAMETRIZAR') &&
        !this.$can('CENTRAL_CADASTROS_INATIVAR_LOTE')
      "
    />
    <div class="row mt-3">
      <tipo-anexo-field
        :modelProp="model"
        ref="tipoAnexoField"
        :disabled="
          !this.$can('CENTRAL_CADASTROS_EDITAR') &&
          !this.$can('CENTRAL_CADASTROS_APROVAR') &&
          !this.$can('CENTRAL_CADASTROS_PARAMETRIZAR') &&
          !this.$can('CENTRAL_CADASTROS_INATIVAR_LOTE')
        "
      />
      <prazo-validade-anexo-field
        :modelProp="model"
        ref="prazoValidadeAnexoField"
        :disabled="
          !this.$can('CENTRAL_CADASTROS_EDITAR') &&
          !this.$can('CENTRAL_CADASTROS_APROVAR') &&
          !this.$can('CENTRAL_CADASTROS_PARAMETRIZAR') &&
          !this.$can('CENTRAL_CADASTROS_INATIVAR_LOTE')
        "
      />
      <descricao-field
        v-if="model"
        :disabled="
          !this.$can('CENTRAL_CADASTROS_EDITAR') &&
          !this.$can('CENTRAL_CADASTROS_APROVAR') &&
          !this.$can('CENTRAL_CADASTROS_PARAMETRIZAR') &&
          !this.$can('CENTRAL_CADASTROS_INATIVAR_LOTE')
        "
        :modelProp="model"
        :isRequired="
          this.model.tipo && this.model.tipo.nome.toLowerCase() === 'outros'
        "
        ref="descricaoAnexoField"
      />
    </div>
    <div class="row mt-5 mb-2">
      <div class="col col-lg-auto ms-auto">
        <button
          @click="resetFields"
          class="btn btn-secondary"
          v-if="
            this.$can('CENTRAL_CADASTROS_EDITAR') ||
            this.$can('CENTRAL_CADASTROS_APROVAR') ||
            this.$can('CENTRAL_CADASTROS_PARAMETRIZAR') ||
            this.$can('CENTRAL_CADASTROS_INATIVAR_LOTE')
          "
        >
          Limpar
        </button>
        <button
          @click="save"
          class="btn btn-primary ms-3"
          v-if="
            this.$can('CENTRAL_CADASTROS_EDITAR') ||
            this.$can('CENTRAL_CADASTROS_APROVAR') ||
            this.$can('CENTRAL_CADASTROS_PARAMETRIZAR') ||
            this.$can('CENTRAL_CADASTROS_INATIVAR_LOTE')
          "
        >
          Adicionar
        </button>
      </div>
    </div>
    <div style="display: flex; align-items: center">
      <form-row-header text="Arquivos Enviados" />
      <help class="ms-2" boxAlign="right">
        Clique na linha para baixar o arquivo
      </help>
    </div>
    <table-arquivos-enviados
      @sortBy="sortBy"
      :anexosList="list"
      @deleteArquivo="remove"
      @downloadArquivo="downloadArquivo"
      :disabled="
        !this.$can('CENTRAL_CADASTROS_EDITAR') &&
        !this.$can('CENTRAL_CADASTROS_APROVAR') &&
        !this.$can('CENTRAL_CADASTROS_PARAMETRIZAR') &&
        !this.$can('CENTRAL_CADASTROS_INATIVAR_LOTE')
      "
    />
  </div>
</template>
<script>
import CRUDTemplate from "@/components/CRUDTemplate";
import FormRowHeader from "@/components/forms/FormRowHeader.vue";
import DescricaoField from "@/components/forms/fields/empresa/DescricaoField.vue";
import InputUploadField from "@/components/forms/fields/empresa/InputUploadField.vue";
import PrazoValidadeAnexoField from "@/components/forms/fields/empresa/PrazoValidadeAnexoField.vue";
import TipoAnexoField from "@/components/forms/fields/empresa/TipoAnexoField.vue";
import TableArquivosEnviados from "@/components/tables/TableArquivosEnviados.vue";
import { HTTP_RESPONSE } from "@/constants/strings";
import ArquivoModel from "@/models/empresa/ArquivoModel";
import EmpresaModel from "@/models/empresa/EmpresaModel";
import ArquivoService from "@/services/portal/empresa/ArquivoService";
import EmpresaService from "@/services/portal/empresa/EmpresaService";
import {
  cleanUpFields,
  downloadFileFromResponseObject,
  mountFormDataForRequest,
} from "@/utils/functionUtils";
import { formIsValid } from "@/utils/validators";

export default {
  extends: CRUDTemplate,
  data() {
    return {
      filter: {
        sort: ["empresaArquivoTipo.nome", "nome"],
      },
    };
  },
  mounted() {
    const { empresaId } = this.$parent;
    this.loading = EmpresaService.getById({ empresaId })
      .then(({ data }) => {
        this.requestEntity = "arquivo";
        this.service = ArquivoService;
        this.model = new ArquivoModel();
        this.empresa = new EmpresaModel(data);
        this.getByEmpresa();
        this.setHeaderText(this.empresa.razaoSocial);
        this.setBreadcrumbsParam(this.empresa.tipo.nome);
      })
      .catch((error) => this.mxHandleRequestError(error, "arquivo"));
  },
  methods: {
    sortBy(emitted) {
      this.filter.sort = emitted;
      this.getByEmpresa();
    },
    getByEmpresa() {
      const { empresaId } = this.$parent;
      const { sort } = this.filter;
      this.loading = this.service
        .getByEmpresa({
          empresaId,
          sort,
        })
        .then(({ data }) => {
          this.list = data || new Array();
        })
        .catch((error) => {
          this.mxHandleRequestError(error, this.requestEntity);
        });
    },
    resetFields() {
      this.model.tipo = "";
      this.model.descricao = "";
      this.model.dataValidade = "";
      this.model.arquivo = null;
      cleanUpFields(this);
    },
    downloadArquivo(arquivo) {
      const { id } = arquivo;
      const { empresaId } = this.$parent;
      this.loading = ArquivoService.downloadArquivo({ id }, empresaId)
        .then(({ data }) =>
          downloadFileFromResponseObject(data, arquivo.getFileName())
        )
        .catch((error) => this.mxHandleRequestError(error, "arquivo"));
    },
    save() {
      if (!formIsValid(this)) return;
      this.mxResetErrorPendencies();
      const { id } = this.empresa;
      const modelData = this.model.getData();
      if (!modelData.descricao) {
        modelData.descricao = "";
      }
      this.loading = ArquivoService.create(
        mountFormDataForRequest(modelData),
        id
      )
        .then(() => {
          this.mxToggleToast(HTTP_RESPONSE.ARQUIVO.SUCCESS.CREATE);
          this.getByEmpresa();
        })
        .catch((error) => this.mxHandleRequestError(error, "arquivo"));
      this.resetFields();
    },
  },
  components: {
    FormRowHeader,
    DescricaoField,
    TipoAnexoField,
    InputUploadField,
    TableArquivosEnviados,
    PrazoValidadeAnexoField,
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/style/style.scss";
@import "@/assets/style/colors.scss";
</style>
